import { nodeListToArray } from '../helpers/nodeListToArray';

export function ctaCardChecker() {
    let rowElements = nodeListToArray(document.querySelectorAll('.row')) as HTMLElement[];

    if (rowElements.length > 0) {

        for (let rowElement of rowElements) {

            let childElements = [].slice.call(rowElement.children) as HTMLElement[];
            let elementsWithCTA = childElements.filter(el => el.classList.contains('ctacardblock'));
            let elementsWithCard = childElements.filter(el => el.classList.contains('cardblock'));
            let elementsWithLinkGroup = childElements.filter(el => el.classList.contains('linkgroupblock'));
            

            if (elementsWithCTA.length > 0  || elementsWithLinkGroup.length > 0) {
                rowElement.classList.add('ctacardblock-row');
            }
            if ( elementsWithCard.length > 0) {
                rowElement.classList.add('cardblock-row');
            }


        }
    }
}